import React, { memo } from "react";

import faTrash from "@fortawesome/fontawesome-free-solid/faTrashAlt";
import faCheck from "@fortawesome/fontawesome-free-solid/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonPicker = memo(
  ({ isUpdateInProcess = true, submitData, removeData }) => {
    return (
      <div
        className={`container-button-picker ${
          isUpdateInProcess ? "" : "disabled-button-time-picker"
        }`}
      >
        <FontAwesomeIcon
          className={`admin-fa-icon icon-check ${
            isUpdateInProcess ? "" : "disabled-button"
          }`}
          onClick={isUpdateInProcess ? e => submitData(e) : null}
          icon={faCheck}
        />
        <FontAwesomeIcon
          className={`admin-fa-icon icon-remove ${
            isUpdateInProcess ? "" : "disabled-button"
          }`}
          onClick={isUpdateInProcess ? e => removeData(e) : null}
          icon={faTrash}
        />
      </div>
    );
  }
);

export default ButtonPicker;
